import Uri from 'jsuri';

const EnvNames = {
  DEV: 'DEV',
  STAGE: 'STAGE',
  PROD: 'PROD',
  QA: 'QA',
  LOCAL: 'LOCAL',
  UAT: 'UAT'
};

const ConnectPortalUrls = {
  [EnvNames.DEV]: 'https://connect.dev.redhat.com/',
  [EnvNames.QA]: 'https://connect.qa.redhat.com/',
  [EnvNames.STAGE]: 'https://connect.stage.redhat.com/',
  [EnvNames.PROD]: 'https://connect.redhat.com/',
  [EnvNames.UAT]: 'https://connect.uat.redhat.com/'
};

// Add any new services consuming hydrajs to below arrays
const getEnvName = () => {
  // Returns PROD | QA | FTE | CI | STAGE
  const prodHostNames = [
    'connect.redhat.com',
    'prod.foo.redhat.com',
    'connect.uat.redhat.com',
    'rhc-certification-workflow-prod.ext.us-west.dc.prod.paas.redhat.com',
  ];
  const qaHostNames = [
    'stage.foo.redhat.com',
    'connect.qa.redhat.com',
    'qa.foo.redhat.com',
    'fte-connect.redhat.com',
    'rhc-certification-workflow-qa.ext.us-west.dc.preprod.paas.redhat.com',
  ];
  const stageHostNames = [
   //'stage.foo.redhat.com',
    'connect.stage.redhat.com',
    'stage-connect.redhat.com',
    'rhc-certification-workflow-stage.ext.us-west.dc.preprod.paas.redhat.com',
  ];
  const devHostNames = [
      'dev-connect.redhat.com',
      'rhc4tp-sandbox1.devlab.redhat.com',
      'rhc4tp-sandbox2.devlab.redhat.com',
      'rhc4tp-sandbox3.devlab.redhat.com',
      'rhc4tp-sandbox4.devlab.redhat.com',
      'rhc4tp-sandbox5.devlab.redhat.com',
      'rhc4tp-mr-app01.devlab.redhat.com',
      'rhc4tp-mr-app02.devlab.redhat.com',
      'rhc4tp-mr-app03.devlab.redhat.com',
      'rhc4tp-mr-app04.devlab.redhat.com',
      'rhc4tp-mr-app05.devlab.redhat.com',
      'rhc4tp-bdunn.devlab.redhat.com',
      'rhc4tp-rcoffman.devlab.redhat.com',
      'rhc4tp.localhost',
      'rhc-certification-workflow-dev.ext.us-west.dc.preprod.paas.redhat.com',
    ];
  const uatHostNames = [];

  if (typeof window !== 'undefined' && window) {
    if (prodHostNames.indexOf(window.location.hostname) !== -1) {
      return EnvNames.PROD;
    } else if (uatHostNames.indexOf(window.location.hostname) !== -1) {
      return EnvNames.UAT;
    } else if (stageHostNames.indexOf(window.location.hostname) !== -1) {
      return EnvNames.STAGE;
    } else if (qaHostNames.indexOf(window.location.hostname) !== -1) {
      return EnvNames.QA;
    } else if (devHostNames.indexOf(window.location.hostname) !== -1) {
      return EnvNames.DEV;
    } else {
      // Returning default value for tests
      return EnvNames.QA;
    }
  }
};

// Returns Pyxis API URL
const getPyxisAPIUrl = () => {
  if (typeof window !== 'undefined' && window) {
      let envQueryParam = new Uri(window.location.search).getQueryParamValue('env')
      switch(envQueryParam ? envQueryParam : getEnvName()) {
        case EnvNames.DEV:
          return new Uri('https://catalog.qa.redhat.com');
        case EnvNames.QA:
          return new Uri('https://catalog.qa.redhat.com');
        case EnvNames.STAGE:
          return new Uri('https://catalog.stage.redhat.com');
        case EnvNames.UAT:
          return new Uri('https://catalog.uat.redhat.com');
        case EnvNames.PROD:
          return new Uri('https://catalog.redhat.com');
        case EnvNames.LOCAL:
          return new Uri('https://pyxis-qa-ext.int.us-west.dc.preprod.paas.redhat.com');
        default:
          return new Uri('https://catalog.stage.redhat.com');
      }
  }
};

// Returns Publishing Service URL
const getPublishingServiceUrl = () => {
  if (typeof window !== 'undefined' && window) {
      let envQueryParam = new Uri(window.location.search).getQueryParamValue('env');
      switch(envQueryParam ? envQueryParam : getEnvName()) {
        case EnvNames.DEV:
          return new Uri('https://rhc-publishing-svc-qa.apps.ext.spoke.preprod.us-east-1.aws.paas.redhat.com');
        case EnvNames.QA:
          return new Uri('https://rhc-publishing-svc-qa.apps.ext.spoke.preprod.us-east-1.aws.paas.redhat.com');
        case EnvNames.STAGE:
          return new Uri('https://rhc-publishing-svc-stage.apps.ext.spoke.preprod.us-east-1.aws.paas.redhat.com');
        case EnvNames.UAT:
          return new Uri('https://test.paas.redhat.com');
        case EnvNames.PROD:
          return new Uri('https://rhc-publishing-svc-prod.apps.ext.spoke.prod.us-west-2.aws.paas.redhat.com');
        case EnvNames.LOCAL:
          return new Uri("https://localhost:8443");
        default:
          return new Uri('https://rhc-publishing-svc-dev.apps.ext.spoke.preprod.us-east-1.aws.paas.redhat.com/');
      }
  }
};

// Returns Hydra API URL
const getHydraAPIUrl = () => {
  if (typeof window !== 'undefined' && window) {
      let envQueryParam = new Uri(window.location.search).getQueryParamValue('env')
      switch(envQueryParam ? envQueryParam : getEnvName()) {
        case EnvNames.DEV:
          return new Uri('https://hydra-prm-qa.ext.us-east.aws.preprod.paas.redhat.com');
        case EnvNames.QA:
          return new Uri('https://connect.qa.redhat.com');
        case EnvNames.STAGE:
          return new Uri('https://connect.stage.redhat.com');
        case EnvNames.UAT:
          return new Uri('https://connect.uat.redhat.com');
        case EnvNames.PROD:
          return new Uri('https://connect.redhat.com');
        case EnvNames.LOCAL:
          return new Uri('https://hydra-prm-qa.ext.us-east.aws.preprod.paas.redhat.com');
        default:
          return new Uri('https://connect.qa.redhat.com');
      }
  }
};


const getStatusPageAPIUrl = () => {
  return new Uri('https://dn6mqn7xvzz3.statuspage.io/');
}

const getRHECUrl = () => {
  if (typeof window !== 'undefined' && window) {
      let envQueryParam = new Uri(window.location.search).getQueryParamValue('env')
      switch(envQueryParam ? envQueryParam : getEnvName()) {
        case EnvNames.DEV:
          return new Uri('https://next-ecocat-dev.ext.us-east.aws.preprod.paas.redhat.com');
        case EnvNames.QA:
          return new Uri('https://catalog.qa.redhat.com');
        case EnvNames.STAGE:
          return new Uri('https://catalog.stage.redhat.com');
        case EnvNames.UAT:
          return new Uri('https://catalog.uat.redhat.com');
        case EnvNames.PROD:
          return new Uri('https://catalog.redhat.com');
        case EnvNames.LOCAL:
          return new Uri('https://next-ecocat-dev.ext.us-east.aws.preprod.paas.redhat.com');
        default:
          return new Uri('https://next-ecocat-dev.ext.us-east.aws.preprod.paas.redhat.com');
      }
  }
}

const isConnectPortal = () => {
  return ([ConnectPortalUrls[EnvNames.PROD], ConnectPortalUrls[EnvNames.STAGE], ConnectPortalUrls[EnvNames.QA], ConnectPortalUrls[EnvNames.DEV], ConnectPortalUrls[EnvNames.UAT]].indexOf(window.location.protocol + "//" + window.location.hostname + "/") !== -1);
};

const getAPIPrefix= () => {
  let envQueryParam = new Uri(window.location.search).getQueryParamValue('env')
  switch(envQueryParam ? envQueryParam : getEnvName()) {
    case EnvNames.DEV:
      return "/api/containers";
    case EnvNames.QA:
      return "/api/containers";
    case EnvNames.STAGE:
      return "/api/containers";
    case EnvNames.UAT:
      return "/api/containers";
    case EnvNames.PROD:
      return "/api/containers";
    default:
      return "/";
  }
};

export const isRhcertUrl = (link: string): boolean => {
  const rhcerthosts = [
    "rhcert.connect.dev.redhat.com",
    "rhcert.connect.preprod.redhat.com",
    "rhcert.connect.redhat.com"
  ]
  return rhcerthosts.filter(uri => link.split("/")?.[2]?.includes(uri))?.length !== 0;
}

const getProductListingUrl = () => {
  if (isConnectPortal()) {
    return ConnectPortalUrls[getEnvName()] + 'manage';
  }
  return 'https://stage.foo.redhat.com:1337/manage';
}

const getDefaultRegistryUrl = () => {
  if (typeof window !== 'undefined' && window) {
      let envQueryParam = new Uri(window.location.search).getQueryParamValue('env');
      switch(envQueryParam ? envQueryParam : getEnvName()) {
        case EnvNames.DEV:
          return "registry.connect.dev.redhat.com";
        case EnvNames.QA:
          return "registry.connect.qa.redhat.com";
        case EnvNames.STAGE:
          return "registry.connect.stage.redhat.com";
        case EnvNames.PROD:
          return "registry.connect.redhat.com";
        case EnvNames.UAT:
          return "registry.connect.uat.redhat.com";
        case EnvNames.LOCAL:
          return "registry.connect.dev.redhat.com";
        default:
          return "registry.connect.dev.redhat.com";
      }
  }
}

// Returns Hydra Proxy URL
const getHydraPoxyUrl = (switchQaToStage?: boolean) => {
  if (typeof window !== 'undefined' && window) {
    let envQueryParam = new Uri(window.location.search).getQueryParamValue('env')
    switch(envQueryParam ? envQueryParam : getEnvName()) {
      case EnvNames.DEV:
        return new Uri('https://access.qa.redhat.com');
      case EnvNames.QA:
        return new Uri(switchQaToStage ? 'https://access.stage.redhat.com':
            'https://access.qa.redhat.com');
      case EnvNames.STAGE:
        return new Uri('https://access.stage.redhat.com');
      case EnvNames.UAT:
        return new Uri('https://test.pass.redhat.com');
      case EnvNames.PROD:
        return new Uri('https://access.redhat.com');
      default:
        return new Uri('https://access.qa.redhat.com');
    }
  }
};

// Returns Pyxis GraphQl API URL
const getPyxisGraphQlAPIUrl = () => {
  if (typeof window !== 'undefined' && window) {
      let envQueryParam = new Uri(window.location.search).getQueryParamValue('env')
      switch(envQueryParam ? envQueryParam : getEnvName()) {
        case EnvNames.DEV:
          return new Uri('https://catalog.qa.redhat.com/api/containers/graphql/');
        case EnvNames.QA:
          return new Uri('https://catalog.qa.redhat.com/api/containers/graphql/');
        case EnvNames.STAGE:
          return new Uri('https://catalog.stage.redhat.com/api/containers/graphql/');
        case EnvNames.UAT:
          return new Uri('https://catalog.uat.redhat.com/api/containers/graphql/');
        case EnvNames.PROD:
          return new Uri('https://catalog.redhat.com/api/containers/graphql/');
        case EnvNames.LOCAL:
          return new Uri('https://pyxis-graphql-qa-ext-pyxis--pyxis-qa.int.us-west.dc.preprod.paas.redhat.com/graphql/');
        default:
          return new Uri('https://pyxis-graphql-qa-ext-pyxis--pyxis-qa.int.us-west.dc.preprod.paas.redhat.com/graphql/');
      }
  }
};

const getPFSAPIUrl = () => {
  const envQueryParam = new Uri(window.location.search).getQueryParamValue('env')
  switch (envQueryParam ? envQueryParam : getEnvName()) {
    case EnvNames.DEV:
      return new Uri('https://connect.qa.redhat.com');
    case EnvNames.QA:
      return new Uri('https://connect.qa.redhat.com');
    case EnvNames.STAGE:
      return new Uri('https://connect.stage.redhat.com');
    case EnvNames.PROD:
      return new Uri('https://connect.redhat.com');
    default:
      return new Uri('https://connect.qa.redhat.com');
  }
};

export default class Env {
  static pyxisAPIURL = getPyxisAPIUrl();
  static pyxisGraphqlAPIURL = getPyxisGraphQlAPIUrl();
  static publishingServiceURL = getPublishingServiceUrl();
  static hydraAPIURL = getHydraAPIUrl();
  static statusPageAPIURL = getStatusPageAPIUrl();
  static RHECUrl = getRHECUrl(); // RedHat Ecosystem Catalog URL
  // Version name: Keep this '' if there's no version.
  // Prefix with / if there is a version prefix eg: '/v1' if url is www.example.com/v1/ping
  static apiPrefix = getAPIPrefix();
  static apiVersion = 'v1';
  static hydraAPIPrefix = '/hydra/prm/v1';
  static hydraV2APIPrefix = '/hydra/prm/v2';
  static getEnvName = getEnvName;
  static EnvNames = EnvNames;
  static ConnectPortalUrls = ConnectPortalUrls;
  static isConnectPortal = isConnectPortal;
  static routePrefix = '/component';
  static oldRoutePrefix = '/projects';
  static productListingUrl = getProductListingUrl();
  static defaultRegistryUrl = getDefaultRegistryUrl();
  static hydraProxyURL = getHydraPoxyUrl();
  static hydraProxyURLPreprodStage = getHydraPoxyUrl(true);
  static hydraProxyPrefix = '/hydra/proxy';
  static pfsNonContainerPrefix = 'pfs/non-cont-crt/projects';
  static hydraCwePrefix = '/hydra/cwe/rest/v1.0/projects';
  static hydraRestPrefix = '/hydra/rest/configuration';
  static productIdStatic = 'view';
  static pfsAPIUrl = getPFSAPIUrl();
  static pfsApiPrefix = '/pfs';
  static isDevEnv = window?.location?.host?.startsWith('stage.foo.redhat.com');
}

export const JWT_SSO_TOKEN_COOKIE_NAME = 'rhc_sso';
export const SAMPLE_JWT_TOKEN = "test-jwt";
export const MONGOID_COOKIE = "mongoid";
